import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Industries from "../pages/industries/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/industries",
    element: <Industries />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
